/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import Api from "../../../../services/ServiceApi";
import Cookies from "js-cookie";
import moment from "moment";
import {
  Table,
  notification,
  Modal,
  Select,
  Input,
  Pagination,
  Button,
  Tooltip,
} from "antd";
import { css } from "emotion";
import { FormatDateTime } from "../../../utility/format";
import AssignModal from "../modal/AssingModal";
import AckjobConfirm from "../modal/AckjobConfirmModal";
import AssignSub from "../modal/AssignSub";
import AssginJobComponent from "../AssignJobcomponent/AssignJobComponent";
import Canceljob from "../modal/Canceljob";
import Subackjob from "../modal/SubAckJob";
import ModalProgressForm from "../modal/ModalProgressForm";
import DynamicButton from "../../../../pages/uih/wf_controllers/BtnController/ButtonController";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";

const { Option } = Select;

const TableCss = css({
  "& table": { fontSize: "18px", fontFamily: "ThaiSansR" },
});

const dateDiff = (item) => {
  var setDisplay = "";
  const startDate = moment(item);
  const timeEnd = moment(new Date());
  const diff = timeEnd.diff(startDate);
  const diffDuration = moment.duration(diff);

  setDisplay = (
    <span
      style={diffDuration.days() < 1 ? { color: "red" } : { color: "#747474" }}
    >
      {diffDuration.days() +
        " D " +
        diffDuration.hours() +
        " H " +
        diffDuration.minutes() +
        " M "}
    </span>
  );

  return setDisplay;
};
const convertNumberToDay = (item) => {
  var setDay = item / 1440;
  var setMin = item - Math.trunc(setDay) * 1440;
  var showDay = Math.trunc(setDay);
  var showHour = Math.trunc(setMin / 60);
  var showMin = setMin - Math.trunc(setMin / 60) * 60;
  var totalTime = showDay + " D " + showHour + " H " + showMin + " M ";

  return totalTime;
};

const showOldBtn = false;
export default function ShowTable({
  dataSource,
  actionBtn,
  currentPage,
  factUpdate,
  LangTranslate,
  SelectJobstatus,
  CountData,
  PageIndex,
  PageSize,
  currentPageS,
}) {
  const { project_id } = useParams();

  const CompanyId = Cookies.get("companyid");
  const OperatorId = Cookies.get("operator_id");
  const ProjectId = Cookies.get("project_id");
  const useDebug = true;
  const [ModalShow, setModalShow] = useState(false);
  const [sendJobdetail, setsendJobdetail] = useState({});
  const [maSkill, setmaSkill] = useState([]);
  const [maTeam, setmaTeam] = useState([]);
  const [workflowJob, setworkflowJob] = useState([]);
  const [CanceljobShow, setCanceljobShow] = useState(false);
  const [ManageMMorSub, setManageMMorSub] = useState(false);
  const [showmodalTranfer, setshowmodalTranfer] = useState(false);
  const [showSubackjob, setshowSubackjob] = useState(false);
  const [showAssignMM, setshowAssignMM] = useState(false);
  const [modalProgressForm, setModalProgressForm] = useState(null);

  // ! new
  const [visibleRecommendation, setVisibleRecommendation] = useState(false);
  const [visibleNonRecommendation, setVisibleNonRecommendation] =
    useState(false);
  // const [jobDetail, setJobDetail] = useState(null);
  // ! new
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const [columns, setcolumns] = useState([
    // {
    //   title: "Opened",
    //   dataIndex: "opened",
    //   key: "opened",
    //   width: 100,
    //   fixed: "left",
    //   sorter: (a, b) => {
    //     return null;
    //   },
    // },
    // {
    //   title: "",
    //   dataIndex: "OverSLA",
    //   key: "opened",
    //   width: 40,
    //   fixed: "left",
    //   render: (text, record) => (
    //     <>
    //       {currentPage === 2 ? (
    //         <img
    //           src={Api.absoluteUrl("/icon/bbtec/body/alert.gif")}
    //           alt=""
    //           style={{ width: "25px", height: "25px" }}
    //         />
    //       ) : null}
    //     </>
    //   ),
    // },
    {
      title: "S/O ID",
      dataIndex: "so_id",
      key: "so_id",
      width: 150,
      fixed: "left",
      align: "center",
      sorter: (a, b) => {
        return a.so_id.length - b.so_id.length;
      },
      render: (text, record) => (
        <a
          href={null}
          className="font-thai-r c-blue text-underline"
          onClick={() =>
            btnFunction.setLinktoController(record.job_id, record.project_id)
          }
        >
          {record.so_id}
        </a>
      ),
    },
    {
      title: "Opcat Tier 1",
      dataIndex: "job_category_name",
      key: "job_category_name",
      width: 200,
      sorter: (a, b) => {
        if (a.job_category_name && b.job_category_name) {
          return a.job_category_name.length - b.job_category_name.length;
        }
      },
      render: (text, record) => (
        <Tooltip placement="top" title={text}>
          <div
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "block",
              overflow: "hidden",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    // {
    //   title: "Job No",
    //   dataIndex: "",
    //   key: "",
    //   width: 120,
    //   sorter: (a, b) => {
    //     return a.job_no - b.job_no;
    //   },
    //   render: (item) => (
    //     <a
    //       href={null}
    //       className="font-thai-r c-blue text-underline"
    //       onClick={() => btnFunction.setLinktoController(item.job_id)}
    //     >
    //       {item.job_no}
    //     </a>
    //   ),
    // },
    {
      title: "SLA Level",
      dataIndex: "sla_name",
      key: "sla_name",
      width: 150,
      sorter: (a, b) => {
        if (a.sla_name && b.sla_name) {
          return a.sla_name.length - b.sla_name.length;
        }
      },
    },
    {
      title: "Status",
      dataIndex: "job_status_name",
      key: "job_status_name",
      width: 200,
      sorter: (a, b) => {
        if (a.job_status_name && b.job_status_name) {
          return a.job_status_name.length - b.job_status_name.length;
        }
      },
      render: (text, record) => (
        <Tooltip placement="top" title={text}>
          <div
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "block",
              overflow: "hidden",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "SubTeam",
      dataIndex: "acknowledge_emp_name",
      key: "acknowledge_emp_name",
      width: 150,
      sorter: (a, b) => {
        if (a.acknowledge_emp_name && b.acknowledge_emp_name) {
          return a.acknowledge_emp_name.length - b.acknowledge_emp_name.length;
        }
      },
      render: (text, record) => (
        <Tooltip placement="top" title={text}>
          <div
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "block",
              overflow: "hidden",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Create Date/Time",
      dataIndex: "create_date",
      key: "create_date",
      width: 160,
      sorter: (a, b) => {
        const st = moment(a.create_date);
        const en = moment(b.create_date);
        return st.diff(en);
      },
      render: (Startdate) => {
        if (Startdate === null) {
          return <span>&nbsp;</span>;
        } else {
          return (
            <span>
              <FormatDateTime text={Startdate}></FormatDateTime>
            </span>
          );
        }
      },
    },
    {
      title: "MM Ack. Date/Time",
      dataIndex: "acknowledge_date",
      key: "acknowledge_date",
      width: 170,
      sorter: (a, b) => {
        const st = moment(a.acknowledge_date);
        const en = moment(b.acknowledge_date);
        return st.diff(en);
      },
      render: (Startdate) => {
        if (Startdate === null) {
          return <span>&nbsp;</span>;
        } else {
          return (
            <span>
              <FormatDateTime text={Startdate}></FormatDateTime>
            </span>
          );
        }
      },
    },
    {
      title: "Event End Time",
      dataIndex: "restoredTime",
      key: "restoredTime",
      width: 160,
      sorter: (a, b) => {
        const st = moment(a.restoredTime);
        const en = moment(b.restoredTime);
        return st.diff(en);
      },
      render: (restoredTime) => {
        if (restoredTime === null) {
          return <span>&nbsp;</span>;
        } else {
          return (
            <span>
              <FormatDateTime text={restoredTime}></FormatDateTime>
            </span>
          );
        }
      },
    },

    {
      title: "MTN Time",
      dataIndex: "total_time",
      key: "total_time",
      width: 180,
      sorter: (a, b) => {
        return null;
      },
      render: (data) => (data === null ? "-" : convertNumberToDay(data)),
    },
    {
      title: "Job Detail",
      dataIndex: "problem_detail",
      key: "problem_detail",
      width: 550,
      // sorter: (a, b) => {
      //   if (a.problem_detail && b.problem_detail) {
      //     return a.problem_detail.length - b.problem_detail.length;
      //   }
      // },
      render: (text, record) => (
        <Tooltip placement="top" title={text}>
          <div
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "block",
              overflow: "hidden",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Last Progressive",
      dataIndex: "progress_detail",
      key: "progress_detail",
      width: 550,
      // fixed: "right",
      // sorter: (a, b) => {
      //   if (a.job_status_name && b.job_status_name) {
      //     return a.job_status_name.length - b.job_status_name.length;
      //   }
      // },
      render: (text, record) => (
        <Tooltip placement="top" title={text}>
          <div
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "block",
              overflow: "hidden",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Assign Group",
      dataIndex: "AssignedGroup",
      key: "AssignedGroup",
      width: 230,
      sorter: (a, b) => {
        if (a.AssignedGroup && b.AssignedGroup) {
          return a.AssignedGroup.length - b.AssignedGroup.length;
        }
      },
      render: (text, record) => (
        <Tooltip placement="top" title={text}>
          <div
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "block",
              overflow: "hidden",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "SAP ID",
      dataIndex: "sap_id",
      key: "sap_id",
      width: 120,
      sorter: (a, b) => {
        return a.sap_id.length - b.sap_id.length;
      },
    },
    {
      title: "Alarm Clear",
      dataIndex: "alarm_clear",
      key: "alarm_clear",
      width: 160,
      sorter: (a, b) => {
        const st = moment(a.restoredTime);
        const en = moment(b.restoredTime);
        return st.diff(en);
      },
      render: (alarm_clear) => {
        if (alarm_clear === null) {
          return <span>&nbsp;</span>;
        } else {
          return (
            <span>
              <FormatDateTime text={alarm_clear}></FormatDateTime>
            </span>
          );
        }
      },
    },
    // {
    //   title: "Site ID",
    //   dataIndex: "job_site_code",
    //   key: "job_site_code",
    //   width: 120,
    //   sorter: (a, b) => {
    //     if (a.job_site_code && b.job_site_code) {
    //       return a.job_site_code.length - b.job_site_code.length;
    //     }
    //   },
    // },

    // {
    //   title: "Site Name",
    //   dataIndex: "job_site_name",
    //   key: "job_site_name",
    //   width: 180,
    //   sorter: (a, b) => {
    //     if (a.job_site_name && b.job_site_name) {
    //       return a.job_site_name.length - b.job_site_name.length;
    //     }
    //   },
    // },
    // {
    //   title: "Center",
    //   dataIndex: "area_code",
    //   key: "area_code",
    //   width: 90,
    //   sorter: (a, b) => {
    //     return a.area_code.length - b.area_code.length;
    //   },
    //   render: (text) => (
    //     <div className="d-flex justify-content-center">
    //       <span className="font-thai-r fs-18">{text}</span>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Impact",
    //   dataIndex: "",
    //   key: "",
    //   width: 50,
    //   align: "center",
    //   render: (text, record) => {
    //     try {
    //       const dataDynamic = JSON.parse(record.data_dynamic);
    //       const impactTable = dataDynamic.find((s) => s.impact_table);
    //       const impactData = impactTable?.impact_table?.table?.data || [];
    //       const filterImpact = impactData.filter(
    //         (f) => f.Circuit_ID + "" !== "0"
    //       );
    //       return filterImpact.length;
    //     } catch (error) {
    //       return "N/A";
    //     }
    //   },
    // },
    // {
    //   title: "Open Time",
    //   dataIndex: "first_Start_date",
    //   key: "first_Start_date",
    //   width: 140,
    //   sorter: (a, b) => {
    //     const st = moment(a.first_Start_date);
    //     const en = moment(b.first_Start_date);
    //     return st.diff(en);
    //   },
    //   render: (Startdate) => {
    //     if (Startdate === null) {
    //       return <span>&nbsp;</span>;
    //     } else {
    //       return (
    //         <span>
    //           <FormatDateTime text={Startdate}></FormatDateTime>
    //         </span>
    //       );
    //     }
    //   },
    // },

    // {
    //   title: "Performance",
    //   dataIndex: "performance",
    //   key: "performance",
    //   align: "center",
    //   width: 120,
    // },
    // {
    //   title: "Performance With Stop Time",
    //   dataIndex: "performance_with_stop_time",
    //   key: "performance_with_stop_time",
    //   align: "center",
    //   width: 200,
    // },
    // {
    //   title: "Job Total Time",
    //   dataIndex: "total_time",
    //   key: "total_time",
    //   width: 180,
    //   sorter: (a, b) => {
    //     return null;
    //   },
    //   render: (data) => (data === null ? "-" : convertNumberToDay(data)),
    // },
    // {
    //   title: "SLA Total Time",
    //   dataIndex: "",
    //   key: "",
    //   width: 180,
    //   sorter: (a, b) => {
    //     return null;
    //   },
    //   render: (data) => dateDiff(data.create_date),
    // },
    // {
    //   title: "SC Staff",
    //   dataIndex: "emp_name",
    //   key: "emp_name",
    //   width: 200,
    //   sorter: (a, b) => {
    //     return null;
    //   },
    // },

    // {
    //   title: "Send To Datc",
    //   dataIndex: "",
    //   key: "",
    //   width: 150, render: (text, record) =>
    //   (
    //     <>
    //       {
    //           record.subprocessid === 30 ||
    //           record.subprocessid === 31 ||
    //           record.subprocessid === 32 ||
    //           record.subprocessid === 33 ||
    //           record.subprocessid === 34 ||
    //           record.subprocessid === 35
    //           ?
    //           <button type="button" class="btn btn-warning">Send To Datc</button>
    //           : null
    //       }

    //     </>
    //   )

    // },
    // {
    //   title: "Recommendation",
    //   dataIndex: "ai_recommend",
    //   key: "ai_recommend",
    //   width: 150,
    //   render: (text, record) => {
    //     return text;
    //   },
    // },
    // {
    //   title: "Action",
    //   dataIndex: "",
    //   key: "",
    //   width: 110,
    //   // fixed: SelectJobstatus === 3 || SelectJobstatus === 1000 ? null : "right",
    //   sorter: () => {
    //     return null;
    //   },
    //   render: (item) => {
    //     if (actionBtn.length > 0) {
    //       const btnFilter = actionBtn.filter(
    //         (data) =>
    //           data.job_type_id === item.job_type_id &&
    //           data.job_category_id === item.job_category_id &&
    //           data.from_main_process_id === item.job_status
    //       );
    //       return (
    //         <DynamicButton
    //           CompanyId={CompanyId}
    //           OperatorId={OperatorId}
    //           ProjectId={ProjectId}
    //           workflow={btnFilter}
    //           page={"ma_list"}
    //           wrapClassName={``}
    //           Jobdetail={item}
    //           language={factUpdate}
    //           factupdate={LangTranslate}
    //         />
    //       );
    //     }
    //   },
    // },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      fixed: "right",
      align: "center",
      render: (item, record) => (
        <Button
          type="primary"
          size="small"
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            height: 23,
            borderRadius: 5,
          }}
          onClick={() =>
            setModalProgressForm({
              jobId: record.job_id,
              CompanyId: CompanyId,
              OperatorId: OperatorId,
              ProjectId: record.project_id,
            })
          }
        >
          Progress
        </Button>
      ),
    },
  ]);

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }

    window.addEventListener("resize", handleResize);

    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  function Callwf(item) {
    Api.post("getButtonDetailWeb", {
      ActionID: 1,
      CompanyID: CompanyId,
      JobTypeID: item.job_type_id,
      MainProcessID: item.main_process_id,
      ProjectID: ProjectId,
      SubProcessID: item.subprocessid,
      UserName: Cookies.get("username"),
      Version: 1,
      WF_ID: 0,
      operator_id: OperatorId,
    })
      .then((res) => {
        if (res.data.result?.code === "P") {
          setworkflowJob(res.data.return_nextWorkFlow);
        } else {
          const args = {
            message: "Error",
            description: res.data.result.description,
            duration: 5,
            className: "font-thai-b",
          };
          notification.error(args);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  const btnFunction = {
    Notiify: function (title, description) {
      const args = {
        message: title,
        description: description,
        duration: 5,
        className: "font-thai-b",
      };
      notification.info(args);
    },
    setLinktoController: function (job_id, project_id) {
      window.open(
        Api.absoluteUrl(
          `/full_detail_job/${CompanyId}/${OperatorId}/${project_id}/${job_id}`
        )
      );
    },
    setLinkToEdit: function (job, btndetail) {
      const job_id = job.job_id;
      window.location.assign(
        Api.absoluteUrl(
          `/Editjob/${CompanyId}/${OperatorId}/${ProjectId}/${job_id}`
        )
      );
    },
    setLinktoCopy: function (job, btndetail) {
      const job_id = job.job_id;
      window.location.assign(
        Api.absoluteUrl(
          `/copyjob/${CompanyId}/${OperatorId}/${ProjectId}/${job_id}`
        )
      );
    },
    Rejectjob: function (job, btndetail) {
      Api.post("/job_detail/go_next_process", {
        ...btndetail,
        operator_id: OperatorId,
        project_id: ProjectId,
        job_id: job.job_id,
        job_progress_id: job.job_progress_id,
        location_lat: 0,
        location_long: 0,
        create_by: Cookies.get("username"),
        job_type_id: job.job_type_id,
      }).then((res) => {
        if (res.data.result.code === "P") {
          this.Notiify("สำเร็จ", "Reject งานเรียบร้อยแล้ว");
        }
      });
    },
    canceljob: async function (job, btndetail) {
      setsendJobdetail(job);
      Callwf(job);
      await setCanceljobShow(true);
    },
    assignMM: async function (job, btndetail) {
      setsendJobdetail(job);
      Callwf(job);
      await setshowAssignMM(true);
    },
    assignSub: async function (job, btndetail) {
      setsendJobdetail(job);
      Callwf(job);
      await setModalShow(true);
    },
    mmAckJob: async function (job, btndetail) {
      setsendJobdetail(job);
      Callwf(job);
      await setModalShow(true);
    },
    subAckJob: async function (job, btndetail) {
      setsendJobdetail(job);
      Callwf(job);
      await setshowSubackjob(true);
    },
    manageMM: async function (job, btndetail) {
      setsendJobdetail(job);
      Callwf(job);
      setManageMMorSub(true);
      await setshowmodalTranfer(true);
    },
    manageSub: async function (job, btndetail) {
      setsendJobdetail(job);
      Callwf(job);
      setManageMMorSub(false);
      await setshowmodalTranfer(true);
    },
  };
  function btnActionmidleware(btndetail, job) {
    const functionNamebyactionId = {
      2: "Rejectjob",
      8: "canceljob",
      16: "assignSub",
      17: "subAckJob",
      23: "assignMM",
      24: "mmAckJob",
      25: "setLinkToEdit",
      40: "manageMM",
      41: "manageSub",
      42: "setLinktoCopy",
    };
    if (btndetail.next_main_action_id) {
      const funcName = functionNamebyactionId[btndetail.next_main_action_id];
      if (funcName) {
        btnFunction[funcName](job, btndetail);
      }
    }
  }
  function onShowSizeChange(current, pageSize) {
    PageIndex(current);
    PageSize(pageSize);
  }

  return (
    <div className="ma-table">
      <Table
        columns={columns}
        className={css(TableCss)}
        // rowKey="uid"
        size="small"
        rowKey="job_id"
        // dataSource={currentPage === 7 || currentPage === 8 ? [] : dataSource}
        dataSource={dataSource}
        // pagination={{ defaultPageSize: 100 }}
        // scroll={{ x: 1200, y: 450 }}
        // sticky={true}
        // bordered
        pagination={false}
        scroll={{ y: dimensions.height - 200 }}
        showSorterTooltip={false}
        rowClassName={(record) => {
          // if (record.ai_recommend) {
          //   return "custom-row tr-info";
          // } else {
          //   return "custom-row tr-default";
          // }
          return "custom-row";
        }}
      />
      <Pagination
        showSizeChanger={false}
        defaultPageSize={40}
        defaultCurrent={currentPageS}
        total={CountData}
        className="m-2"
        style={{ float: "right" }}
        onChange={onShowSizeChange}
      />
      {/* <Table columns={columns2} dataSource={data} scroll={{ x: 1300 }} /> */}
      {ManageMMorSub ? (
        <AssginJobComponent
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={showmodalTranfer}
          setModalShow={setshowmodalTranfer}
          workflowJob={workflowJob ? workflowJob : null}
          jobDetail={sendJobdetail}
          currentPage={currentPage}
          title={"Manage M&M"}
          AdvanceSearch={true}
          showOldassign={true}
          showStartasAckJob={false}
          typeModal={"manage"}
          Teamgroupdutycode={"C"}
          ShowMap={true}
          EnableAssignTeam={false}
        ></AssginJobComponent>
      ) : (
        <AssginJobComponent
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={showmodalTranfer}
          setModalShow={setshowmodalTranfer}
          workflowJob={workflowJob ? workflowJob : null}
          jobDetail={sendJobdetail}
          currentPage={currentPage}
          title={"Manage Sub"}
          typeModal={"manage"}
          AdvanceSearch={true}
          showOldassign={true}
          showStartasAckJob={true}
          Teamgroupdutycode={"O"}
          ShowMap={true}
          EnableAssignTeam={false}
        ></AssginJobComponent>
      )}
      {currentPage === 1 ? (
        <AssignModal
          ModalShow={ModalShow}
          setModalShow={setModalShow}
          type={currentPage === 1 ? "AssignMM" : "Assign Sub"}
          currentPage={currentPage}
          jobDetail={sendJobdetail}
          workflowJob={workflowJob ? workflowJob : null}
          dataSelect={setModalShow ? maSkill : null}
        ></AssignModal>
      ) : null}
      {currentPage === 2 ? (
        <AckjobConfirm
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={ModalShow}
          setModalShow={setModalShow}
          workflowJob={workflowJob ? workflowJob : null}
          jobDetail={sendJobdetail}
          currentPage={currentPage}
        ></AckjobConfirm>
      ) : null}
      {currentPage === 3 ? (
        useDebug ? (
          <AssginJobComponent
            CompanyId={CompanyId}
            OperatorId={OperatorId}
            ProjectId={ProjectId}
            ModalShow={ModalShow}
            setModalShow={setModalShow}
            workflowJob={workflowJob ? workflowJob : null}
            jobDetail={sendJobdetail}
            currentPage={currentPage}
            title={"Assign to sub "}
            typeModal={"assign"}
            AdvanceSearch={true}
            showOldassign={false}
            showStartasAckJob={false}
            Teamgroupdutycode={"O"}
            ShowMap={true}
            EnableAssignTeam={false}
          ></AssginJobComponent>
        ) : (
          <AssignSub
            ModalShow={ModalShow}
            setModalShow={setModalShow}
            workflowJob={workflowJob ? workflowJob : null}
            jobDetail={sendJobdetail}
            currentPage={currentPage}
            dataSelect={currentPage === 3 ? maSkill : null}
            dataTeam={currentPage === 3 ? maTeam : null}
          ></AssignSub>
        )
      ) : null}
      {CanceljobShow ? (
        <Canceljob
          jobDetail={sendJobdetail}
          workflowJob={workflowJob ? workflowJob : null}
          Modalshow={CanceljobShow}
          setModalshow={setCanceljobShow}
        ></Canceljob>
      ) : null}
      {showSubackjob ? (
        <Subackjob
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={showSubackjob}
          setModalShow={setshowSubackjob}
          workflowJob={workflowJob ? workflowJob : null}
          jobDetail={sendJobdetail}
          currentPage={currentPage}
        ></Subackjob>
      ) : null}
      {showAssignMM ? (
        <AssginJobComponent
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={showAssignMM}
          setModalShow={setshowAssignMM}
          workflowJob={workflowJob ? workflowJob : null}
          jobDetail={sendJobdetail}
          currentPage={currentPage}
          title={"Assign to MM "}
          typeModal={"assign"}
          AdvanceSearch={true}
          showOldassign={false}
          showStartasAckJob={false}
          Teamgroupdutycode={"C"}
          ShowMap={true}
          EnableAssignTeam={false}
        ></AssginJobComponent>
      ) : null}

      <Modal
        className="bbtec-theme modal-center"
        title="JOB : 20210403000264"
        visible={visibleRecommendation}
        // onOk={() => setVisibleRecommendation(false)}
        onCancel={() => setVisibleRecommendation(false)}
        bodyStyle={{ padding: 5 }}
        footer={[
          <button
            className="btn btn-back"
            style={{ width: 140 }}
            onClick={() => setVisibleRecommendation(false)}
          >
            Back
          </button>,
          <button
            className="btn btn-submit"
            style={{ width: 140 }}
            onClick={() => setVisibleRecommendation(false)}
          >
            Confirm
          </button>,
        ]}
      >
        <div className="row justify-content-center">
          <div className="col-auto">
            <img
              src={Api.absoluteUrl("/img/boxes-rafiki.svg")}
              alt="boxes-rafiki"
            />
          </div>
        </div>
        <div
          className="row justify-content-center mt-3 mb-3"
          style={{ backgroundColor: "#F8F9FB", padding: "15px 0px" }}
        >
          <div className="col-5">
            <div className="row mb-2">
              <div className="col-12 c-blue">
                <div className="row" style={{ margin: "0 -10px" }}>
                  <img
                    src={Api.absoluteUrl("/icon/job_maintenance.svg")}
                    alt="job_maintenance"
                  />
                  <span style={{ paddingLeft: 10 }}>Job Detail</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                style={{ width: 2, background: "#E8ECEF", marginLeft: 15 }}
              />
              <div className="col-10">
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    Skill
                  </div>
                  <div className="col-auto">Xxxxxxxxx</div>
                </div>
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    Area
                  </div>
                  <div className="col-auto">BKK</div>
                </div>
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    On hand
                  </div>
                  <div className="col-auto">{`> 5`}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-5">
            <div className="row mb-2">
              <div className="col-12 c-blue">
                <div className="row" style={{ margin: "0 -10px" }}>
                  <img
                    src={Api.absoluteUrl("/icon/bbtec/body/Job-Assignment.svg")}
                    alt="job_maintenance"
                  />
                  <span style={{ paddingLeft: 10 }}>Recommendation</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                style={{ width: 2, background: "#E8ECEF", marginLeft: 15 }}
              />
              <div className="col-10">
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    Skill
                  </div>
                  <div className="col-auto c-success">100%</div>
                </div>
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    Area
                  </div>
                  <div className="col-auto c-success">100%</div>
                </div>
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    On hand
                  </div>
                  <div className="col-auto c-success">100%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        className="bbtec-theme modal-center"
        title="JOB : 20210403000264"
        visible={visibleNonRecommendation}
        // onOk={() => setVisibleRecommendation(false)}
        onCancel={() => setVisibleNonRecommendation(false)}
        bodyStyle={{ padding: 5 }}
        footer={[
          <button
            className="btn btn-back"
            style={{ width: 140 }}
            onClick={() => setVisibleNonRecommendation(false)}
          >
            Back
          </button>,
          <button
            className="btn btn-submit"
            style={{ width: 140 }}
            onClick={() => setVisibleNonRecommendation(false)}
          >
            Confirm
          </button>,
        ]}
      >
        <div
          className="row justify-content-center mt-3 mb-3"
          style={{ backgroundColor: "#F8F9FB", padding: "15px 0px" }}
        >
          <div className="col-5">
            <div className="row mb-2">
              <div className="col-12 c-blue">
                <div className="row" style={{ margin: "0 -10px" }}>
                  <img
                    src={Api.absoluteUrl("/icon/job_maintenance.svg")}
                    alt="job_maintenance"
                  />
                  <span style={{ paddingLeft: 10 }}>Job Detail</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                style={{ width: 2, background: "#E8ECEF", marginLeft: 15 }}
              />
              <div className="col-10">
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    Skill
                  </div>
                  <div className="col-auto">Xxxxxxxxx</div>
                </div>
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    Area
                  </div>
                  <div className="col-auto">BKK</div>
                </div>
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    On hand
                  </div>
                  <div className="col-auto">{`> 5`}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-5">
            <div className="row mb-2">
              <div className="col-12 c-blue">
                <div className="row" style={{ margin: "0 -10px" }}>
                  <img
                    src={Api.absoluteUrl("/icon/bbtec/body/Job-Assignment.svg")}
                    alt="job_maintenance"
                  />
                  <span style={{ paddingLeft: 10 }}>Recommendation</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                style={{ width: 2, background: "#E8ECEF", marginLeft: 15 }}
              />
              <div className="col-10">
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    Skill
                  </div>
                  <div className="col-auto c-success">100%</div>
                </div>
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    Area
                  </div>
                  <div className="col-auto c-success">100%</div>
                </div>
                <div className="row">
                  <div className="c-blue" style={{ width: 50 }}>
                    On hand
                  </div>
                  <div className="col-auto c-success">100%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center mb-3">
          <div className="col-10">
            <div className="row">
              <span className="font-thai-r fs-18">Reason</span>
            </div>
            <div className="row">
              <Select
                name="reason"
                defaultValue=""
                style={{ border: "0px", width: "100%" }}
                placeholder="Select a Team Sub"
                className="inputfile"
                // onChange={handleSelectChange}
                // value={selsectTeamSub}
              >
                <Option value="">Xxxxxxxxxxxxxx</Option>
              </Select>
            </div>
          </div>
          <div className="col-10">
            <div className="row">
              <span className="font-thai-r fs-18">Suggestion</span>
            </div>
            <div className="row">
              <Input.TextArea
                name="employmentReason"
                className="inputfile c-blue"
                // value={employment.employmentReason}
                rows={4}
                // onChange={(e) => {
                //   const { value } = e.target;
                //   setEmployment({
                //     ...employment,
                //     employmentReason: value,
                //   });
                // }}
              />
            </div>
          </div>
        </div>
      </Modal>
      <ModalProgressForm
        data={modalProgressForm}
        onCancel={() => setModalProgressForm()}
      />
    </div>
  );
}
